/* istanbul ignore file */
import { InMemoryCache } from '@apollo/client';
import {
  mergeCallConversations,
  mergeListBy,
  mergeSearchItemsCollection,
  mergeUserAssociatedLines,
} from '@helpers/cache.helpers';

export const createCache = (): InMemoryCache =>
  new InMemoryCache({
    typePolicies: {
      Agent: {
        keyFields: ['ID'],
      },
      AgentEmailNotification: {
        keyFields: ['ID'],
      },
      AgentPhoneNumber: {
        keyFields: ['ID'],
      },
      AgentV2: {
        keyFields: ['ID'],
        fields: {
          associatedLines: {
            keyArgs: false,
            merge: mergeUserAssociatedLines,
          },
        },
      },
      Application: {
        keyFields: ['id', 'name', 'source'],
      },
      BlacklistedNumbers: {
        keyFields: [],
        fields: {
          blacklistedPhoneNumbers: {
            merge: mergeListBy('__ref'),
          },
        },
      },
      CallConversation: {
        keyFields: ['callId'],
      },
      CalendarOutput: {
        keyFields: ['calendarID'],
      },
      BasicCall: {
        keyFields: ['callId'],
      },
      Company: {
        keyFields: ['ID'],
      },
      ContactsSearchResult: {
        keyFields: ['contact', ['phoneNumber']],
      },
      ConversationAgent: {
        keyFields: ['agentDetails', ['agentId']],
      },
      ConversationContact: {
        keyFields: ['phoneNumber'],
      },
      FlowConfigurationOutput: {
        keyFields: ['lineID'],
      },
      Integration: {
        keyFields: ['id', 'name'],
      },
      IntegrationConnectedLines: {
        keyFields: ['id', 'integrationType', 'pagination', ['page', 'limit']],
      },
      Line: {
        keyFields: ['ID'],
      },
      LineSettingsOutput: {
        keyFields: ['lineID'],
      },
      LineTranscriptionSettings: {
        keyFields: ['lineId'],
      },
      NotificationsConfiguration: {
        keyFields: [],
      },
      NumberAttributes: {
        keyFields: ['number'],
      },
      Team: {
        keyFields: ['ID'],
      },
      TeamAttributes: {
        keyFields: ['name'],
      },
      UserCriticalAction: {
        keyFields: ['agentID', 'action'],
      },
      CompanyBillingDetailsOutput: {
        keyFields: ['ID'],
      },
      CompanyAddon: {
        keyFields: ['name'],
        merge: true,
      },
      Query: {
        fields: {
          getCallConversations: {
            keyArgs: false,
            merge: mergeCallConversations,
          },
          searchAgents: {
            keyArgs: () => ['filter', 'sort'],
            merge: mergeSearchItemsCollection(),
          },
          searchTeams: {
            keyArgs: (_args, context) => {
              /* istanbul ignore next */
              if (context.field?.alias) {
                return ['filter', 'from', 'limit'];
              }
              return ['filter', 'sort'];
            },
            merge: mergeSearchItemsCollection(),
          },
          searchLines: {
            keyArgs: (_args, context) => {
              if (context.field?.alias) {
                return ['filter', 'from', 'limit'];
              }
              return ['filter', 'sort'];
            },
            merge: mergeSearchItemsCollection(),
          },
          listCalendars: {
            keyArgs: ['filter', 'sort'],
            merge: mergeSearchItemsCollection((args) => !args.token),
          },
        },
      },
    },
  });
